import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const Login = ({ closeModal, setLoggedInUser }) => {
  const [activeTab, setActiveTab] = useState("user");
  const navigate = useNavigate();

  const loginUser = (event) => {
    event.preventDefault();

    const email = event.target.elements.loginEmail.value;
    const password = event.target.elements.loginPassword.value;

    let loginUrl = "https://journey-scape-main.vercel.app/api/auth/login";
    if (activeTab === "admin") {
      loginUrl = "https://journey-scape-main.vercel.app/api/auth/adminlogin";
    }

    axios
      .post(loginUrl, { email, password })
      .then((response) => {
        const { success, message, user } = response.data;
        if (success) {
          alert(message);
          closeModal();
          setLoggedInUser(user.name);

          if (activeTab === "admin") {
            navigate("/Dashboard"); // Navigate to admin dashboard
          }
        } else {
          alert(message);
        }
      })
      .catch((error) => {
        console.error(error);
        alert("Failed to login: " + error.message);
      });
  };

  return (
    <div>
      <ul className="nav nav-tabs">
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "user" ? "active" : ""}`}
            onClick={() => setActiveTab("user")}
          >
            User
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "admin" ? "active" : ""}`}
            onClick={() => setActiveTab("admin")}
          >
            Admin
          </button>
        </li>
      </ul>
      <form id="loginForm" onSubmit={loginUser}>
        <div className="form-group">
          <input
            type="email"
            className="form-control"
            id="loginEmail"
            placeholder="Email"
            required
          />
        </div>
        <div className="form-group">
          <input
            type="password"
            className="form-control"
            id="loginPassword"
            placeholder="Password"
            required
          />
        </div>
        <button type="submit" className="btn btn-primary btn-block w-100">
          Login
        </button>
      </form>
      <p className="mt-3">
        {activeTab === "user" ? (
          <>
            Don't have an account? <span>Check Register Form</span>
          </>
        ) : (
          <>
            Don't have an account? <span>Ask Admin to Add</span>
          </>
        )}
      </p>
    </div>
  );
};

export default Login;
